import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingSku } from './types';

export function useBillingPackSkus(packId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<TBillingSku[]>(
    packId ? `commenda-billing/catalog/packs/${packId}/skus` : null,
    SWRFetcher({ method: 'GET' })
  );

  return { skus: data ?? [], error, isLoading, mutate };
}
